import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendCsvFile, BackendMutationUploadCsvArgs } from 'src/types/backend';

import { FRAGMENT_CSV_FILE } from './schema';

const MUTATION = gql`
  mutation UploadCsv($csv: Upload!, $customerId: ID!) {
    uploadCsv(csv: $csv, customerId: $customerId) {
      ...CSVFile
    }
  }
  ${FRAGMENT_CSV_FILE}
`;

type Variables = BackendMutationUploadCsvArgs;
type Result = BackendCsvFile;

export const uploadCsvFile = async (variables: Variables) => {
  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(response.data);
};
